import {
  getPublicApiBaseUrl,
  getPublicPayByInvoiceEnabled,
  getPublicPlatformSubscriptionsEnabled,
  getPublicRegisterAgentEnabled,
  getPublicSapExportToolEnabled,
  getPublicSystemStatusEnabled,
} from "./public-runtime-config";

export const features = {
  get platformSubscriptionsEnabled() {
    return getPublicPlatformSubscriptionsEnabled();
  },
  get registerAgentEnabled() {
    return getPublicRegisterAgentEnabled();
  },
  get payByInvoice() {
    return getPublicPayByInvoiceEnabled();
  },
  get systemStatusEnabled() {
    return getPublicSystemStatusEnabled();
  },
  get sapExportToolEnabled() {
    return getPublicSapExportToolEnabled();
  },
  get apiBaseUrl() {
    return getPublicApiBaseUrl();
  },
} as const;
